import { Link } from "react-router-dom";
import { LanguageMenu, SmartLink } from "@/components/Header";
import { footerColumns, legalLinks } from "@/data/site";
import { EmailLink } from "@/components/EmailLink";

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-background">
      <div className="cm-container py-16 sm:py-24">
        <div className="grid gap-12 md:grid-cols-[1.6fr_repeat(4,1fr)] lg:gap-16">
          <div>
            <Link to="/" aria-label="ClearMakes home" className="inline-flex items-center gap-3">
              <img src="/logo-mark-256.png" alt="" width={56} height={56} className="h-14 w-14" />
              <span className="text-[1.7rem] font-bold tracking-[-0.03em] text-foreground">ClearMakes</span>
            </Link>
            <p className="mt-6 max-w-[280px] text-[19px] font-semibold leading-snug tracking-[-0.015em] text-foreground">
              Less coordination. More finished work.
              <span className="block font-normal text-muted-foreground">Intelligent software for the way teams actually work.</span>
            </p>
            <EmailLink email="contact@clearmakes.com" className="mt-5 inline-block text-[14px] text-foreground cm-link">
              contact@clearmakes.com
            </EmailLink>
          </div>

          {footerColumns.map((col) => (
            <nav key={col.heading} aria-label={col.heading}>
              <p className="text-[14px] font-semibold text-foreground">{col.heading}</p>
              <ul className="mt-5 space-y-3.5">
                {col.links.map((l) => (
                  <li key={l.href + l.label}>
                    <SmartLink href={l.href} className="text-[14px] text-muted-foreground transition-colors hover:text-foreground">
                      {l.label}
                    </SmartLink>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-20 flex flex-col gap-5 border-t border-border pt-8 text-[13px] text-muted-foreground lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
            <p>© {new Date().getFullYear()} ClearMakes. All rights reserved.</p>
            <ul className="flex flex-wrap gap-x-5 gap-y-2">
              {legalLinks.map((l) => (
                <li key={l.href}>
                  <SmartLink href={l.href} className="transition-colors hover:text-foreground">
                    {l.label}
                  </SmartLink>
                </li>
              ))}
            </ul>
          </div>
          <LanguageMenu pill />
        </div>
      </div>
    </footer>
  );
};
